module.exports = __webpack_public_path__ + "img/nuclear-power.4b13332b.png";